import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
import PropTypes from 'prop-types'
import MembersLoading from './MembersLoading'

export default function LetsPlayLoading({ label, detail, compact = false }) {
  const { t } = useOptionalPrivanaI18n()
  return <MembersLoading label={label || t("memberWorkflows.golf.loadingLetSPlay")} detail={detail} compact={compact} className="mp-play-loading--lets-play" />
}

LetsPlayLoading.propTypes = {
  label: PropTypes.string,
  detail: PropTypes.string,
  compact: PropTypes.bool,
}
